import { OrderDirection } from '@api/twin/AnomalyApi';
import { datadogRum } from '@datadog/browser-rum';
import { usePluginTranslation } from '@translation';
import { useState } from 'react';
import { AnomalySectionLayout } from '../tabs/AnomalySectionLayout';
import { AnomalyHistoryList } from './AnomalyHistoryList';
import { SwitchOrderDirectionButton } from './SwitchOrderDirectionButton';

export const AnomalyHistory = () => {
  const { t } = usePluginTranslation();
  const [orderDirection, setOrderDirection] = useState<OrderDirection>('asc');

  const onChange = (orderDirection: OrderDirection) => {
    setOrderDirection(orderDirection);
    datadogRum.addAction('tvp.anomaly.history.sort', {
      orderDirection,
    });
  };

  return (
    <AnomalySectionLayout
      title={t('anomaly_plugin.widget.sections.history_section.title')}
      headerRight={
        <SwitchOrderDirectionButton orderDirection={orderDirection} onChange={onChange} />
      }
    >
      <AnomalyHistoryList orderDirection={orderDirection} />
    </AnomalySectionLayout>
  );
};
